(function () {
    const WISHLIST_KEY = 'shopify-wishlist';

    window.Wishlist = {
        get: function () {
            try {
                return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
            } catch (e) {
                return [];
            }
        },

        toggle: function (product) {
            let items = this.get();
            const index = items.findIndex(item => item.id == product.id);

            if (index === -1) {
                items.push(product);
            } else {
                items.splice(index, 1);
            }

            localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
            this.updateUI();
            document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: items }));
        },

        remove: function (productId) {
            let items = this.get();
            items = items.filter(item => item.id != productId);
            localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
            this.updateUI();
            document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: items }));
        },

        isAnimatingFirst: false,

        updateUI: function () {
            const items = this.get();
            const count = items.length;

            // Update Header bubbles
            const bubbles = document.querySelectorAll('.wishlist-count-bubble');
            bubbles.forEach(bubble => {
                const countSpan = bubble.querySelector('span[aria-hidden="true"]');
                if (countSpan) countSpan.textContent = count;
                bubble.style.display = count > 0 ? 'flex' : 'none';
            });

            // Update Header Icon Active State
            const wishlistIcon = document.querySelector('#wishlist-icon-bubble');
            if (wishlistIcon) {
                if (count === 0) {
                    wishlistIcon.classList.remove('is-active');
                } else if (!this.isAnimatingFirst) {
                    wishlistIcon.classList.add('is-active');
                }
            }

            // Update Buttons in product pages and cards
            const buttons = document.querySelectorAll('.wishlist-btn');
            buttons.forEach(btn => {
                const id = btn.dataset.productId;
                const isActive = items.some(item => item.id == id);
                btn.classList.toggle('active', isActive);
            });

            // Update Drawer if open
            if (window.renderWishlistDrawerItems) {
                window.renderWishlistDrawerItems(items);
            }
        },

        animateFly: function (sourceBtn, isFirst) {
            const target = document.querySelector('#wishlist-icon-bubble .icon');
            const wishlistBtnHeader = document.querySelector('#wishlist-icon-bubble');
            if (!target) return;

            const sourceRect = sourceBtn.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();

            const flyItem = document.createElement('div');
            flyItem.className = 'wishlist-fly-item';

            // Clone SVG from source
            const sourceSvg = sourceBtn.querySelector('svg');
            if (sourceSvg) {
                const svg = sourceSvg.cloneNode(true);
                flyItem.appendChild(svg);
            }

            // Standard button size for the circle
            const initialSize = 34;

            // Center the initial circle on the source button
            flyItem.style.top = `${sourceRect.top + (sourceRect.height - initialSize) / 2}px`;
            flyItem.style.left = `${sourceRect.left + (sourceRect.width - initialSize) / 2}px`;
            flyItem.style.width = `${initialSize}px`;
            flyItem.style.height = `${initialSize}px`;

            document.body.appendChild(flyItem);

            if (isFirst) {
                this.isAnimatingFirst = true;
            }

            // Trigger animation
            requestAnimationFrame(() => {
                flyItem.style.top = `${targetRect.top}px`;
                flyItem.style.left = `${targetRect.left}px`;
                flyItem.style.width = `${targetRect.width}px`;
                flyItem.style.height = `${targetRect.height}px`;
                flyItem.style.opacity = '0';
                flyItem.style.background = 'transparent';
                flyItem.style.boxShadow = 'none';
                flyItem.style.padding = '0';
            });

            flyItem.addEventListener('transitionend', () => {
                flyItem.remove();

                if (isFirst) {
                    this.isAnimatingFirst = false;
                    if (this.get().length > 0) {
                        wishlistBtnHeader.classList.add('is-active');
                    }
                }

                target.classList.add('wishlist-pulse-active');
                setTimeout(() => target.classList.remove('wishlist-pulse-active'), 400);
            });
        },

        init: function () {
            // Estratégia: só toggle se o usuário apertou E soltou em CIMA do mesmo .wishlist-btn,
            // sem ter movido o ponteiro mais que DRAG_THRESHOLD. Bloqueia o click default
            // sempre — não confiamos no click do navegador (ele dispara mesmo depois de drag).
            const self = this;
            let downBtn = null, downX = 0, downY = 0;
            const DRAG_THRESHOLD = 8; // px

            document.addEventListener('pointerdown', (e) => {
                downBtn = e.target.closest('.wishlist-btn');
                downX = e.clientX;
                downY = e.clientY;
            }, { capture: true });

            document.addEventListener('pointerup', (e) => {
                if (!downBtn) return;
                const stillBtn = e.target.closest('.wishlist-btn');
                const dx = e.clientX - downX;
                const dy = e.clientY - downY;
                const moved = Math.sqrt(dx * dx + dy * dy);
                const intentionalTap = (downBtn === stillBtn) && (moved < DRAG_THRESHOLD);

                const btnRef = downBtn;
                downBtn = null;

                if (!intentionalTap) return;

                e.preventDefault();
                e.stopPropagation();

                const product = {
                    id: btnRef.dataset.productId,
                    handle: btnRef.dataset.productHandle,
                    title: btnRef.dataset.productTitle,
                    image: btnRef.dataset.productImage,
                    price: btnRef.dataset.productPrice
                };

                const items = self.get();
                const isAdding = !items.some(item => item.id == product.id);
                const isFirst = items.length === 0 && isAdding;

                self.toggle(product);

                if (isAdding) {
                    self.animateFly(btnRef, isFirst);
                }
            }, { capture: true });

            // Cancela o evento click default do navegador no botão de wishlist —
            // não usamos mais ele, todo o toggle vem do pointerup acima.
            document.addEventListener('click', (e) => {
                const btn = e.target.closest('.wishlist-btn');
                if (btn) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
            }, true);

            // Limpa estado se o pointer for cancelado (ex: scroll iniciar)
            document.addEventListener('pointercancel', () => { downBtn = null; }, { capture: true });

            this.updateUI();
        }
    };

    document.addEventListener('DOMContentLoaded', () => window.Wishlist.init());
})();
